import { Component, OnInit } from '@angular/core';
import {ITableHeader} from "../../../../../interfaces/table-header";
import {TableHeaderService} from "../../../../../resources/services/table-header.service";

@Component({
  selector: 'ui-users',
  templateUrl: './ui-users.component.html'
})
export class UiUsersComponent implements OnInit {

  headers: ITableHeader[] = [
    this.tableHeaderService.account({sort: false}),
    this.tableHeaderService.store({sort: false}),
    this.tableHeaderService.createdAt({filter: false}),
    this.tableHeaderService.info({sort: false}),
    this.tableHeaderService.coins(),
    this.tableHeaderService.authAt({filter: false})
  ];

  data: any = {
    id: '0987654321',
    store: {
      name: 'StoreName',
      id: '0987654321'
    },
    createdAt: new Date(),
    authAt: new Date(),
  };
  textInfo = 'Andrey Shirokov; 23 y.o; Russia Moscow ul. Malaya Caretnaya 32-2 227';

  source: any[] = new Array(9).fill(this.data);

  constructor(private tableHeaderService: TableHeaderService) { }

  ngOnInit(): void {
    this.source[0] = this.source[6] = { ...this.data, email: 'example@email.com', active: true, info: this.textInfo };
    this.source[2] = { ...this.data, email: 'example@email.com', active: false, info: this.textInfo };
  }

}
